var _path, _path2, _path3, _path4, _path5, _path6, _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockAdjustmentReason({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 71,
    viewBox: "0 0 75 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1496 55.209L32.5849 56.4947H38.832L65.2085 59.9233L54.7967 63.7804L58.2673 70.209L41.6085 65.4947L40.2202 70.209L32.5849 65.4947L23.5614 68.9233L24.9496 63.7804L6.20847 60.7804L24.9496 59.9233L13.1496 55.209Z",
    fill: "#DADFF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6476 20.3882L20.3882 0L-2.67843e-06 42.2595L42.2595 62.6476L62.6476 20.3882Z",
    fill: "#CCE5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4328 58.1557L2.17331 37.7676L0.00600907 42.2598L42.2655 62.648L44.4328 58.1557Z",
    fill: "#28345A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2839 50.1675L62.6502 20.3897L32.8725 6.02344L48.2839 50.1675Z",
    fill: "#EFEFFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0056 12.3602L37.0211 8.02557L30.7945 20.9317L39.7791 25.2663L46.0056 12.3602Z",
    fill: "#027BC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6661 24.0614L7.30109 16.8181L10.6604 10.9433L21.788 24.2126L18.3845 32.4615L23.2135 34.9264L26.3297 42.1092L10.2626 32.3103L13.6661 24.0614Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.2881,
    cy: 14.396,
    r: 11.6851,
    fill: "#CCE5FF",
    stroke: "#28345A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.478,
    y: 5.46094,
    width: 1.62467,
    height: 12.9974,
    rx: 0.812337,
    fill: "#28345A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.478,
    y: 20.082,
    width: 1.62467,
    height: 1.62467,
    rx: 0.812337,
    fill: "#28345A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockAdjustmentReason);
export default __webpack_public_path__ + "static/media/stockAdjustmentReason.3ffdfd55404b445f5ffb38d757001c2c.svg";
export { ForwardRef as ReactComponent };